/**
 * 首登强制设密码页（任务 6e-2；旧版 set_password_page.dart 口径）。
 *
 * 进入条件：logged-in 且 needsPassword（验证码登录后 profile.HasPassword=false，
 * 标记持久化在凭证记录——刷新/冷启动也会被守卫强制回到这里）。独立路由
 * /set-password 而非登录卡片子视图：此时用户已登录，守卫不许停留在 /login。
 *
 * 不可跳过：守卫把其他页面一律 replace 回来；唯一逃脱口是「退出登录」。
 * 成功后组件不导航——needsPassword 清零，守卫自动 replace 回原页。
 */
import { useState } from 'preact/hooks';
import styles from './login.module.scss';
import { appWorker } from '~/store/appWorker';
import { globalStore } from '~/store/global';
import { logoutToLogin, setInitialPassword } from '~/store/authActions';
import { BRAND_NAME } from '~/brand';

export function SetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(event: Event) {
    event.preventDefault();
    if (busy || password === '' || confirm === '') return;
    if (password !== confirm) {
      setError('两次密码输入不一致');
      return;
    }
    setBusy(true);
    setError('');
    const result = await setInitialPassword(appWorker(), globalStore(), password);
    setBusy(false);
    if (!result.ok) setError(result.message);
  }

  async function logout() {
    if (busy) return;
    setBusy(true);
    await logoutToLogin(appWorker(), globalStore());
  }

  return (
    <div className={styles.loginPage} data-testid="page-set-password">
      <div className={styles.card}>
        <h1 className={styles.brand}>{BRAND_NAME}</h1>
        <h2 className={styles.viewTitle}>设置登录密码</h2>
        <p className={styles.hint}>请先设置密码以保障账号安全</p>
        <form className={styles.form} onSubmit={submit}>
          <input
            className={styles.input}
            data-testid="setpwd-new"
            type="password"
            placeholder="请输入新密码"
            autocomplete="new-password"
            value={password}
            onInput={(e) => setPassword(e.currentTarget.value)}
          />
          <input
            className={styles.input}
            data-testid="setpwd-confirm"
            type="password"
            placeholder="请再次输入新密码"
            autocomplete="new-password"
            value={confirm}
            onInput={(e) => setConfirm(e.currentTarget.value)}
          />
          {error !== '' && (
            <p className={styles.error} data-testid="setpwd-error">
              {error}
            </p>
          )}
          <button
            className={styles.submit}
            data-testid="setpwd-submit"
            type="submit"
            disabled={busy || password === '' || confirm === ''}
          >
            {busy ? '请稍候…' : '确认设置'}
          </button>
          <button
            type="button"
            className={styles.linkButton}
            data-testid="setpwd-logout"
            onClick={logout}
          >
            退出登录
          </button>
        </form>
      </div>
    </div>
  );
}
